import ServiceApi from '../services/service.api';
import { LabTestSchema } from '../schemas/shared/lab';
import { safeParse } from '../schemas/helpers/safeParse';

const baseServiceUrl = `/labs`;

const ApiLabs = {
  getLabs: async (query: any) => {
    const params = {
      status: '',
      ...query
    };
    return ServiceApi.get(`${baseServiceUrl}/labs/${ServiceApi.userGuid}`, {
      params
    })
      .then((res) => (res.data ? res.data : { labs: [] }))
      .then((data) => {
        return safeParse(data, LabTestSchema);
      });
  },
  resetOrderId: (ext_order_id: string) => {
    const params = {
      // @ts-ignore
      user_guid: ServiceApi.userGuid,
      ext_order_id
    };
    return ServiceApi.post(`${baseServiceUrl}/order/remove`, params) as Promise<{
      data: any;
      status: number;
      statusText: string;
    }>;
  },
  chaseResults: (params: { user_guid: string; ext_order_id: string }) => {
    return ServiceApi.post(`${baseServiceUrl}/order/chase`, params);
  },
  changePriority: (appointmentId: number, orderLocation: string, selectedPriority: string, selectedReason: string) => {
    const params = {
      user_guid: ServiceApi.userGuid,
      appt_id: appointmentId,
      urg_code: selectedPriority,
      urgency_change_code: selectedReason,
      order_route_code: orderLocation
    };
    return ServiceApi.post(`${baseServiceUrl}/lab/urgency`, params);
  },
  changeOrderStatus: (params: { user_guid: string; appt_id: number; order_route_code: string; status: string }) => {
    return ServiceApi.post(`${baseServiceUrl}/order/status`, params);
  }
};

export default ApiLabs;
